import { render, staticRenderFns } from "./FormExtendModal.vue?vue&type=template&id=279c409a&scoped=true"
import script from "./FormExtendModal.vue?vue&type=script&lang=js"
export * from "./FormExtendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c409a",
  null
  
)

export default component.exports